import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {CatalogNavigationService} from "../../services/catalog-navigation/catalog-navigation.service";
import {CatalogDataModel} from "../../../../core/services/catalog-data/catalog-data.model";

@Component({
  selector: 'sb-catalog-item',
  templateUrl: './catalog-item.component.html',
  styleUrls: ['./catalog-item.component.scss']
})
export class CatalogItemComponent implements OnInit, OnDestroy {

  @Input()
  item: CatalogDataModel;

  constructor(private catalogNavigationService: CatalogNavigationService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  clickItem(itemId: string) {
    this.catalogNavigationService.clickItem(itemId);
  }
}
